export const effectiveDate = '2024-04-08T00:00:00';
export const viewOnlyDate = '2024-05-20T00:00:00';
export const learnMoreUrl =
  'https://support.atlassian.com/trello/docs/workspace-user-limit/';
